import React from "react";
import { CpIcon } from "@components";
import { m } from "kremling";
import { EmptyCell } from "./empty-cell.component";

type BoolCellProps = {
  value: boolean;
  isDisabled?: boolean;
};

export function BoolCell({ value, isDisabled }: BoolCellProps) {
  return value ? (
    <span className={m("cp-data-table-cell-disabled", isDisabled)}>
      <CpIcon name="checkmark-large" />
    </span>
  ) : (
    <EmptyCell isDisabled={isDisabled} />
  );
}

BoolCell.overrideEmptyCell = true;
